import styled from 'styled-components';

export const BaseFiltroAvancadoItemStyleModalHeader = styled.div`
  .header {
    background-color: ${(props) => (props.theme.primary)}
  }
`;

export const BaseFiltroAvancadoItemStyleH5 = styled.div`
  color: ${(props) => (props.theme.primary)}
`;

export const BaseFiltroAvancadoItemStyleH3 = styled.div`
  .h3 {
    background-color: ${(props) => (props.theme.primary)} !important;
  }

  .h3-style {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #ffffff;
  }
`;

export const BaseFiltroAvancadoItemStyleButton = styled.div`
  .button-primary {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #ffffff

  }
  .button-primary:hover{
    opacity: 0.7;
  }
  .button-secondary {
    background-color: ${(props) => (props.theme.buttonSecondary)} !important;
    color: #ffffff
  }

  .button-white {
    color: ${(props) => (props.theme.whiteButton)} !important;
  }

  .nav-link-tab-modal:active{
    border-top: 2px solid ${(props) => (props.theme.primary)} !important;
    background: white;
  }
`;

export const BaseFiltroAvancadoItemStyleTextColor = styled.div`
  .label {
    display:flex;
    align-items: center;
    justify-content: flex-start;
  }

  .p {
    color: ${(props) => (props.theme.textColor)}
   }

`;
